module.exports = __webpack_public_path__ + "img/TS6301-309.816fce3b.jpg";